module.exports = __webpack_public_path__ + "download/static/img/download.b683f6c0.png";